import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { FunctionComponent, useState } from 'react';
import styles from './DeleteBelongingModal.module.scss';

export interface DeleteBelongingModalProps {
    belongingName: string;
    isLoading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DeleteBelongingModal: FunctionComponent<DeleteBelongingModalProps> = ({
    belongingName,
    isLoading,
    onConfirm,
    onCancel
}) => {
    const [loading, setLoading] = useState(false);

    const confirmHandler = () => {
        setLoading(true);
        onConfirm();
    };

    return (
        <GenericModal
            className={styles.modal}
            onClose={onCancel}
            footer={
                <div className={styles.footer}>
                    <div className={styles.left}>
                        <Button
                            className={styles.button}
                            label="No"
                            onClick={onCancel}
                            variant="black"
                        />
                    </div>
                    <div className={styles.right}>
                        <Button
                            className={styles.button}
                            label="Delete"
                            onClick={confirmHandler}
                            variant="danger"
                            isLoading={loading || isLoading}
                        />
                    </div>
                </div>
            }
        >
            <div className={styles.titleContainer}>
                <span
                    className={styles.title}
                    title={`Delete ${belongingName}`}
                >
                    Delete {belongingName}
                </span>
            </div>
            <span className={styles.body}>Are you sure you want to delete this belonging?</span>
        </GenericModal>
    );
};

export default DeleteBelongingModal;
